import { GetExpenseResponse, GetUserType } from '@orbit/api-types'
import React from 'react'
import { Avatar } from '../Avatar'
import { ActivityPerson, formatAmount, getInvolvementText, getUserInvolvement } from '../balancesFormat'
import {
	ActivityCard,
	ActivityCardBottom,
	ActivityCardCurrencyCode,
	ActivityCardInvolvement,
	ActivityCardLeft,
	ActivityCardName,
	ActivityCardThumbnail,
	ActivityCardTop,
	PaidConnector,
	PayerAmount,
	PayerLine,
	PayerName,
} from './ActivitySection.styles'
import { TestIds } from '@/testIds'

interface Props {
	expense: GetExpenseResponse
	/** The signed-in viewer; undefined on the public surface (no involvement line). */
	me: GetUserType | undefined
	payer: ActivityPerson | undefined
	payerShortName: string
	payerFullName: string
	thumbnailUrl: string | undefined
	showCurrencyCode: boolean
	/** Omit to render the card read-only (public surface). */
	onClick?: () => void
}

const ExpenseCard: React.FC<Props> = ({
	expense,
	me,
	payer,
	payerShortName,
	payerFullName,
	thumbnailUrl,
	showCurrencyCode,
	onClick,
}) => {
	const involvement = getUserInvolvement(expense, me)
	const isMePayer = !!me && expense.paidByUserId === me.id
	return (
		<ActivityCard $interactive={!!onClick} onClick={onClick} data-testid={TestIds.expense.cell(expense.name)}>
			<ActivityCardTop>
				<ActivityCardLeft>
					<ActivityCardName>{expense.name}</ActivityCardName>
				</ActivityCardLeft>
				{thumbnailUrl && <ActivityCardThumbnail src={thumbnailUrl} alt={expense.name} />}
			</ActivityCardTop>
			<ActivityCardBottom>
				<PayerLine>
					<Avatar member={payer} size="sm" />
					<PayerName $highlight={isMePayer} title={isMePayer ? undefined : payerFullName}>
						{isMePayer ? 'You' : payerShortName}
					</PayerName>
					<PaidConnector>paid</PaidConnector>
					<PayerAmount>
						{formatAmount(expense.amount, expense.currencyCode)}
						{showCurrencyCode && (
							<ActivityCardCurrencyCode>
								{expense.currencyCode.toUpperCase()}
							</ActivityCardCurrencyCode>
						)}
					</PayerAmount>
				</PayerLine>
				{/* No viewer identity (public surface) → "not involved" would be noise. */}
				{me && (
					<ActivityCardInvolvement $type={involvement.type}>
						{getInvolvementText(expense, me)}
					</ActivityCardInvolvement>
				)}
			</ActivityCardBottom>
		</ActivityCard>
	)
}

export default ExpenseCard
